export const VIDEO_STREAM_URL = `${window.ENV.HTTP_URL}/video/stream`
